(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('PaymentsQueryRequest', function () {

        function PaymentsQueryRequest() {
            this.order = '-paymentDate';
            this.page = 1;
            this.limit = 5;
        }

        return PaymentsQueryRequest;
    });
})();
